
export default function initGlobal() {

    // Display/reveal zip/city list in the top of the footer.
    let list = document.querySelector('.zip-city-list');
    let desc = document.querySelector('.zip-city-desc');
    let reveal = document.querySelector('.reveal-zip');
    if (list) {
        reveal.addEventListener('click', (event) => {
            list.classList.toggle("js-open");
        });
    }

    // setTimeout(function () {
    //     let map = document.querySelector('.map-wrapper');
    //     let html = map.textContent.replace(/\n/g, '');
    //     map.textContent = html;
    //     console.log('Refreshing...');
    //     initDots();
    // }, 500);

    // Init dots initially for other browsers.
    var initDots = function () {
        // initialize map dots.
        let svg = document.querySelector('.map-wrapper svg');
        if (svg) {
            let dots = document.querySelectorAll('.map-wrapper svg .city-dot');
            //console.log(dots);
            for (var i = 0; i < dots.length; i++) {
                let dot = dots[i];
                setOnDotClickUrl(dot);
            }
            var cities = document.querySelector('.cities');
            if (cities) {
                let current = cities.getAttribute('data-current');
                if (current) {
                    let to_mark_selector = 'a[data-name="' + current + '"]';
                    let to_mark_circle = 'svg g#' + current;
                    document.querySelector(to_mark_selector).classList.add("active");
                    document.querySelector(to_mark_circle).classList.add('active');
                }
            }
        }
    };

    var setOnDotClickUrl = function (dot) {
        let selector = 'a[data-name="' + dot.id + '"]';
        let url = document.querySelector(selector).getAttribute('href');
        if (!url)
            console.warn('Missing url for', dot.id);
        dot.addEventListener('click', (event) => {
            window.open(url, '_blank');
        });
    };

    initDots();

}
